/**
 * TanStack Query mutation for bulk session review save.
 * POST /api/session-reviews/bulk
 */
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from '@client/lib/api-client';
import { sessionDashboardKeys } from './use-session-dashboard';

export interface ReviewInput {
  enrollmentId: string;
  participation: number;
  comprehension: number;
  behavior: number;
  comment?: string;
}

export interface BulkReviewBody {
  sessionId: string;
  reviews: ReviewInput[];
}

export function useBulkSaveReviews(classId: string, sessionId: string) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (body: BulkReviewBody) =>
      api.post<unknown>('/api/session-reviews/bulk', body),
    onSuccess: () => {
      void qc.invalidateQueries({
        queryKey: sessionDashboardKeys.bySession(classId, sessionId),
      });
    },
  });
}
